<template>
  <form class="mt-2" id="leave-form">
    <div class="mt-2">
      <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Date <span class="text-danger"></span></label>
      <input class="form-control" name="leaveDate" v-model="leaveDate" type="date"  />
    </div>
    <div class="mt-2">
      <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Reason <span style="color: red">*</span>:</label>
      <textarea type="text" class="form-control" name="reason" v-model="reason" placeholder="Enter Reason" required></textarea>
    </div>

    <br>
    <div class="text-right">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="clear">
        Close
      </button>
      <button type="button" :style="[isMiniLoading ? { 'pointer-events': 'none' } : { 'pointer-events': 'auto' }]" class="btn btn-default ml-1" @click="save">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Save
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";

export default {
  props: ["action", "formData"],
  data() {
    return {
      isMiniLoading: false,
      reason: "",
      leaveDate :"",
    };
  },
  methods: {
    save() {
      const permission = {
        headers: {
          'X-Permission': 'admin_users_onleave'
        }
      };

      axios
        .post("/admin/users/onleave", {
          reason: this.reason,
          date: this.leaveDate,
          user_id: this.formData.id,
        }, permission)
        .then((response) => {
          this.isMiniLoading = false;
          this.$toast.success("Leave saved successfully");
          window.$("#modal").modal("hide");
          this.clear();
        })
        .catch((error) => {
          this.isMiniLoading = false;
          this.$toast.error("Error occurred while saving leave");
          console.error(error);
        });
    },
  
    clear() {
      this.reason = "";
      this.leaveDate = "";
    }
  }
};
</script>